export enum UserPermissions {
  FreeAccess = 2911,
  InsightCollectionDocuments = 2913,
}
